

// class ModalDialog extends HTMLElement {
//   constructor() {
//     super();
//     this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this));
//     this.addEventListener('click', (event) => {
//       if (event.target.nodeName === 'MODAL-DIALOG') this.hide()
//     });
//     this.addEventListener('keyup', () => {
//       if(event.code.toUpperCase() === 'ESCAPE') this.hide();
//     });
//   }

//   show(opener) {
//     this.openedBy = opener;

//     document.body.classList.add('overflow-hidden');
//     console.log(this);
//     this.setAttribute('open', '');
//     trapFocus(this);
//   }

//   hide() {
//     document.body.classList.remove('overflow-hidden');
//     this.removeAttribute('open');
//     removeTrapFocus(this.openedBy);
//   }
// }
// customElements.define('modal-dialog', ModalDialog);

// class ModalOpener extends HTMLElement {
//   constructor() {
//     super();

//     const button = this.querySelector('button');
//     button?.addEventListener('click', () => {
//       document.querySelector(this.getAttribute('data-modal'))?.show(button);
//     });
//   }
// }
// customElements.define('modal-opener', ModalOpener);

$('#mobile-slider li').on('click',function(){
document.getElementsByClassName('product-media-modal')[0].setAttribute('open','')});

$('.product-media-modal__toggle').on('click',function(){
document.getElementsByClassName('product-media-modal')[0].removeAttribute('open','')});